"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariationType = void 0;
var VariationType;
(function (VariationType) {
    VariationType["STRING"] = "STRING";
    VariationType["INTEGER"] = "INTEGER";
    VariationType["NUMERIC"] = "NUMERIC";
    VariationType["BOOLEAN"] = "BOOLEAN";
    VariationType["JSON"] = "JSON";
})(VariationType = exports.VariationType || (exports.VariationType = {}));
//# sourceMappingURL=interfaces.js.map